import { ApplicationConfig, provideBrowserGlobalErrorListeners, provideZonelessChangeDetection } from '@angular/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter } from '@angular/router';
import { routes } from './app.routes';
import { provideLeerplusRidGame } from './leerplus/rid-game.setup';

export const appConfig: ApplicationConfig = {
  providers: [
    provideAnimations(), // for leerplus
    provideBrowserGlobalErrorListeners(),
    provideZonelessChangeDetection(),
    provideRouter(routes),
    provideLeerplusRidGame(),
  ],
};
